<template>
  <div v-if="CaseShow" id="EditCase2" style="padding: 0 1em">
    <div class="course_title">編輯申請</div>

    <div class="table-responsive-sm">
      <table class="table" style="width: 100%; text-align: left">
        <tbody>
          <tr>
            <td colspan="5" align="left">
              <span style="color: #f00"
                ><span style="color: #f00">＊</span>為必填項目。</span
              >
            </td>
          </tr>

          <tr align="left">
            <td colspan="5">
              申請本助學金，家庭年所得不能超過70萬，計算標準比照大專校院弱勢學生入學計畫：<br />
              1、未婚者：未成年與其父母或法定監護人合計；已成年與其父母或未成年時之法定監護人合計。<br />
              2、已婚者：與其配偶合計。<br />
              3、離婚或配偶死亡者：為同學本人之所得總額。<br />
              4、其他特殊條件：因父母離婚、遺棄或其他特殊因素，與父母或法定監護人合計顯失公平者，<br />
              得敘明理由，並检具相關文件資料（如近３個月內之詳細記事戶籍謄本或其他文件），經學校審查認定後，<br />
              該父母或法定監護人免予合計。
            </td>
          </tr>
          <tr align="left">
            <td colspan="5" class="d-flex flex-wrap" style="gap:0 1.5rem">
              <span style="white-space:nowrap">申請日期：{{ getToday() }}</span>
              <span style="white-space:nowrap">申請學年/學期：{{ queryInfo.schyy }}/{{ queryInfo.smt }}</span>
            </td>
          </tr>
          <!-- 欄位標題：sm 以上才顯示 -->
          <tr class="d-none d-sm-table-row" align="left">
            <td colspan="5" class="px-0 py-1">
              <div class="row no-gutters mx-0 rel-row">
                <div class="col-auto px-2">編號</div>
                <div class="col px-1">關係人姓名</div>
                <div class="col-auto px-1">與學生關係</div>
                <div class="col-auto px-1">國籍</div>
                <div class="col px-1">身分證 / 居留證字號</div>
              </div>
            </td>
          </tr>

          <!-- 關係人1：手機折三行（編號+姓名 / 關係+國籍 / 身分證），桌機單行 -->
          <tr>
            <td colspan="5" class="px-0 py-1">
              <div class="row no-gutters align-items-start mx-0 rel-row">
                <div class="col-auto d-flex align-items-center py-1 px-2">
                  <strong>1</strong>
                </div>
                <div class="col mb-1 mb-sm-0 px-1">
                  <small class="d-block d-sm-none text-muted">關係人姓名</small>
                  <input
                    type="text"
                    class="form-control"
                    v-model="queryInfo.relatedName1"
                    placeholder="輸入姓名"
                    maxlength="60"
                  />
                </div>
                <div class="col-6 col-sm-auto mb-1 mb-sm-0 px-1">
                  <small class="d-block d-sm-none text-muted">與學生關係</small>
                  <b-form-select
                    v-model="queryInfo.relatedStudent1"
                    :options="options1"
                  ></b-form-select>
                </div>
                <div class="col-6 col-sm-auto mb-1 mb-sm-0 px-1">
                  <small class="d-block d-sm-none text-muted">國籍</small>
                  <b-form-select
                    v-model="queryInfo.relatedNationality1"
                    :options="nationalityOptions"
                  ></b-form-select>
                </div>
                <div class="col-12 col-sm px-1">
                  <small class="d-block d-sm-none text-muted">身分證/居留證字號</small>
                  <input
                    type="text"
                    class="form-control"
                    v-model="queryInfo.relatedId1"
                    :placeholder="queryInfo.relatedNationality1 === 'TW' ? '輸入身分證字號' : '輸入居留證號碼'"
                    @input="onIdInput(1)"
                    @blur="validateIdOnBlur(1)"
                  />
                  <small v-if="idError1" style="color:#f00">{{ idError1 }}</small>
                </div>
              </div>
            </td>
          </tr>

          <!-- 關係人2 -->
          <tr>
            <td colspan="5" class="px-0 py-1">
              <div class="row no-gutters align-items-start mx-0 rel-row">
                <div class="col-auto d-flex align-items-center py-1 px-2">
                  <strong>2</strong>
                </div>
                <div class="col mb-1 mb-sm-0 px-1">
                  <small class="d-block d-sm-none text-muted">關係人姓名</small>
                  <input
                    type="text"
                    class="form-control"
                    v-model="queryInfo.relatedName2"
                    placeholder="輸入姓名"
                    maxlength="60"
                  />
                </div>
                <div class="col-6 col-sm-auto mb-1 mb-sm-0 px-1">
                  <small class="d-block d-sm-none text-muted">與學生關係</small>
                  <b-form-select
                    v-model="queryInfo.relatedStudent2"
                    :options="options2"
                  ></b-form-select>
                </div>
                <div class="col-6 col-sm-auto mb-1 mb-sm-0 px-1">
                  <small class="d-block d-sm-none text-muted">國籍</small>
                  <b-form-select
                    v-model="queryInfo.relatedNationality2"
                    :options="nationalityOptions"
                  ></b-form-select>
                </div>
                <div class="col-12 col-sm px-1">
                  <small class="d-block d-sm-none text-muted">身分證/居留證字號</small>
                  <input
                    type="text"
                    class="form-control"
                    v-model="queryInfo.relatedId2"
                    :placeholder="queryInfo.relatedNationality2 === 'TW' ? '輸入身分證字號' : '輸入居留證號碼'"
                    @input="onIdInput(2)"
                    @blur="validateIdOnBlur(2)"
                  />
                  <small v-if="idError2" style="color:#f00">{{ idError2 }}</small>
                </div>
              </div>
            </td>
          </tr>

          <!-- 關係人3 -->
          <tr>
            <td colspan="5" class="px-0 py-1">
              <div class="row no-gutters align-items-start mx-0 rel-row">
                <div class="col-auto d-flex align-items-center py-1 px-2">
                  <strong>3</strong>
                </div>
                <div class="col mb-1 mb-sm-0 px-1">
                  <small class="d-block d-sm-none text-muted">關係人姓名</small>
                  <input
                    type="text"
                    class="form-control"
                    v-model="queryInfo.relatedName3"
                    placeholder="輸入姓名"
                    maxlength="60"
                  />
                </div>
                <div class="col-6 col-sm-auto mb-1 mb-sm-0 px-1">
                  <small class="d-block d-sm-none text-muted">與學生關係</small>
                  <b-form-select
                    v-model="queryInfo.relatedStudent3"
                    :options="options3"
                  ></b-form-select>
                </div>
                <div class="col-6 col-sm-auto mb-1 mb-sm-0 px-1">
                  <small class="d-block d-sm-none text-muted">國籍</small>
                  <b-form-select
                    v-model="queryInfo.relatedNationality3"
                    :options="nationalityOptions"
                  ></b-form-select>
                </div>
                <div class="col-12 col-sm px-1">
                  <small class="d-block d-sm-none text-muted">身分證/居留證字號</small>
                  <input
                    type="text"
                    class="form-control"
                    v-model="queryInfo.relatedId3"
                    :placeholder="queryInfo.relatedNationality3 === 'TW' ? '輸入身分證字號' : '輸入居留證號碼'"
                    @input="onIdInput(3)"
                    @blur="validateIdOnBlur(3)"
                  />
                  <small v-if="idError3" style="color:#f00">{{ idError3 }}</small>
                </div>
              </div>
            </td>
          </tr>

          <tr align="left">
            <td><span style="color: #f00">＊</span>戶籍謄本</td>
            <td colspan="4">
              <b-form-file
                class="mb-2"
                ref="file-input"
                :no-drop="true"
                :no-traverse="true"
                v-model="queryInfo.file"
                @input="fileChange(0)"
                placeholder="上傳戶籍謄本"
                accept=".jpg, .jpeg, .png, .gif, .pdf"
                browse-text="選擇檔案"
              ></b-form-file>
              <span v-if="queryInfo.file.RowId != undefined">
                <a
                  :href="'./WebApi/Common/GetDocumentFile/' + queryInfo.file.RowId"
                  target="_blank"
                >
                  <img src="@/assets/images/disk.png" />
                </a>
                {{ queryInfo.file.RowId != undefined ? queryInfo.file.name : '' }}
              </span>
            </td>
          </tr>
          <tr align="left">
            <td>本人同意</td>
            <td colspan="4">
              送出申請的文字：
              本人確認有中華民國戶籍，就讀本校「產學攜手合作計畫」專班，具有學籍且修業年限內之學生。<br />
              同意教育部函請財政部資訊中心查調家庭年所得，若申請後有不符資格者，<br />
              薏無條件將已獲學校补助之助學金款項繳回，絕無異議。特此聲明。
            </td>
          </tr>
          <tr>
            <td colspan="5" style="text-align: center">
              <button
                class="btn active bg-info text-white rounded"
                @click="confirmRM()"
              >
                送出資料
              </button>
              &nbsp;
              <b-button @click="hideModal()">
                <b-icon icon="x" />&nbsp;{{ $t('message.Close_cmd') }}
              </b-button>
              &nbsp;
              <b-button
                style="width: 6.5rem"
                type="reset"
                @click="onReset"
                variant="danger"
              >Reset</b-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import * as tools from '../tool'

// 後端承辦人專用：編輯學生經濟不利助學金申請（含補件處理）
//
// ⚠️  【維護注意】
// 以下三個元件共用相同的申請表單結構（關係人3列 + 國籍 + 戶籍謄本 + 本人同意）：
//   1. AddNewCaseView.vue  ← 學生新申請，上傳 API: UploadV2
//   2. EditCase.vue        ← 學生編輯申請，上傳 API: UploadV3
//   3. EditCase2.vue       ← 本檔，承辦人編輯申請，上傳 API: UploadV3
// 若需修改表單欄位、驗證邏輯或文字，三個元件都必須一併更新。
// 對應後端 API（需同步確認）：
//   - EconomicDisadvantage/EditCase
//   - EconomicDisadvantage/GetCaseDetail
//   - EconomicDisadvantage/DeleteApplyPDF2
//   - Common/UploadV3
export default {
  name: 'EditCase2',
  props: ['id'], // id：由父元件傳入，對應資料庫申請案件的 rowId
  data () {
    return {
      CaseShow: false,
      nationalityOptions: [
        { value: 'TW', text: '本國籍' },
        { value: 'FN', text: '外國籍' }
      ],
      idError1: '',
      idError2: '',
      idError3: '',
      relatedStudent1: null,
      options1: [
        { value: null, text: '請選擇' },
        { value: 1, text: '父親' },
        { value: 2, text: '母親' },
        { value: 3, text: '配偶' },
        { value: 5, text: '法定代理人' }
      ],
      relatedStudent2: null,
      options2: [
        { value: null, text: '請選擇' },
        { value: 1, text: '父親' },
        { value: 2, text: '母親' },
        { value: 3, text: '配偶' },
        { value: 5, text: '法定代理人' }
      ],
      relatedStudent3: null,
      options3: [
        { value: null, text: '請選擇' },
        { value: 1, text: '父親' },
        { value: 2, text: '母親' },
        { value: 3, text: '配偶' },
        { value: 5, text: '法定代理人' }
      ],
      relatedName1: null,
      relatedName2: null,
      relatedName3: null,
      relatedId1: null,
      relatedId2: null,
      relatedId3: null,
      memberShow: this.$store.state.user2,
      inputData: this.$store.state.inputData,
      inputData2: null,
      mode: false,
      file: [{ name: '', RowId: '' }],
      total: 0,
      isIE: false,
      selectedRowIndex: 0,
      currentPage: 1,
      pageSize: 10,
      queryInfo: {
        DataMode: 0, // 0: 未異動，1: 重新上傳戶籍謄本
        id: '',
        stdID: '',
        Info1: [], // 上傳成功後由 fileChange 寫入伺服器端檔案資訊
        file: [], // 現有附件資訊（name, RowId）或新選取的 File 物件
        sid: '',
        relatedName1: null,
        relatedName2: null,
        relatedName3: null,
        relatedId1: null,
        relatedId2: null,
        relatedId3: null,
        relatedStudent1: null,
        relatedStudent2: null,
        relatedStudent3: null,
        relatedNationality1: 'TW',
        relatedNationality2: 'TW',
        relatedNationality3: 'TW',
        schyy: null,
        smt: null,
        UpdateUser: null,
        reason: null,
        rowId: '' // 現有戶籍謄本的 RowId，有值代表已有附件
      }
    }
  },
  computed: {
    filteredDocs: function () {
      let data = []
      if (this.inputData != null) {
        data = this.inputData.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        )
      }
      return data
    },
    headerColor () {
      return '#f7e8aa'
    }
  },
  methods: {
    // 關閉 Modal，通知父元件隱藏對話框
    hideModal () {
      this.$emit('hideModal')
    },

    // 重設表單所有關係人欄位、國籍選擇、錯誤訊息及附件至初始狀態
    onReset () {
      const vm = this
      vm.queryInfo.relatedStudent1 = null
      vm.queryInfo.relatedStudent2 = null
      vm.queryInfo.relatedStudent3 = null
      vm.queryInfo.relatedName1 = ''
      vm.queryInfo.relatedName2 = ''
      vm.queryInfo.relatedName3 = ''
      vm.queryInfo.relatedId1 = ''
      vm.queryInfo.relatedId2 = ''
      vm.queryInfo.relatedId3 = ''
      vm.queryInfo.relatedNationality1 = 'TW'
      vm.queryInfo.relatedNationality2 = 'TW'
      vm.queryInfo.relatedNationality3 = 'TW'
      vm.idError1 = ''
      vm.idError2 = ''
      vm.idError3 = ''
      vm.queryInfo.file[0] = [{ name: '', RowId: '' }]
    },
    // 通知父元件切換至指定案件頁面
    CaseSelect (id) {
      this.$emit('CaseSelect', id)
    },

    // 通用空值判斷：空字串、null、undefined 均視為空
    isEmpty (data) {
      return !(data !== '' && data !== null && data !== undefined)
    },
    // 判斷戶籍謄本檔案是否缺少：現有檔案（rowId）或新上傳的 File 物件擇一即可
    FileisEmpty (file) {
      const hasExistingFile = !tools.isNull(this.queryInfo.rowId)
      const hasNewFile = file instanceof File && file.size > 0
      return !hasExistingFile && !hasNewFile
    },

    // 關係人身分證/居留證輸入時：轉大寫並清除錯誤訊息，n 為關係人編號（1~3）
    onIdInput (n) {
      const val = this.queryInfo['relatedId' + n]
      if (val) {
        this.queryInfo['relatedId' + n] = val.toUpperCase()
      }
      this['idError' + n] = ''
    },
    // 關係人身分證/居留證欄位失焦時即時驗證格式，n 為關係人編號（1~3）
    validateIdOnBlur (n) {
      const id = this.queryInfo['relatedId' + n]
      const nat = this.queryInfo['relatedNationality' + n]
      const rel = this.queryInfo['relatedStudent' + n]
      if (!id) {
        this['idError' + n] = ''
        return
      }
      const ok = nat === 'TW' ? tools.checkTWID(id) : tools.checkARC(id)
      if (!ok) {
        this['idError' + n] = '格式不正確'
        return
      }
      this['idError' + n] = tools.checkGenderMatch(id, nat, rel) ? '' : '性別與關係不符（父親應為男性、母親應為女性）'
    },

    // 驗證本國身分證格式（舊方法，現統一改用 tool.checkTWID 驗證，保留以備參考）
    checkVal (str) {
      var regExp = /^[A-Z]\d{9}$/
      if (regExp.test(str)) return true
      else return false
    },
    /**
     * 送出前欄位驗證。
     * 關係人1：若三欄不全為空則均必填且格式必須正確。
     * 關係人2/3：以姓名是否填寫為觸發條件，有填姓名則其餘必填。
     * 身分證/居留證依國籍選擇分別呼叫 checkTWID 或 checkARC。
     * 回傳空字串表示通過，非空字串為錯誤訊息。
     */
    checkSaveData () {
      var msg = ''

      // 關係人1：若三欄不全為空則進行驗證
      const isRelated1AllEmpty =
    this.isEmpty(this.queryInfo.relatedId1) &&
    this.isEmpty(this.queryInfo.relatedName1) &&
    this.isEmpty(this.queryInfo.relatedStudent1)

      if (!isRelated1AllEmpty) {
        if (this.isEmpty(this.queryInfo.relatedId1)) {
          msg = '請輸入關係人身分證1'
          return msg
        }

        var ret1 = this.queryInfo.relatedNationality1 === 'TW'
          ? tools.checkTWID(this.queryInfo.relatedId1)
          : tools.checkARC(this.queryInfo.relatedId1)
        if (!ret1) {
          msg = '關係人1身分證/居留證格式不正確'
          return msg
        }

        if (!tools.checkGenderMatch(this.queryInfo.relatedId1, this.queryInfo.relatedNationality1, this.queryInfo.relatedStudent1)) {
          msg = '關係人1性別與關係不符（父親應為男性、母親應為女性）'
          return msg
        }

        if (this.isEmpty(this.queryInfo.relatedName1)) {
          msg = '請輸入關係人姓名1'
          return msg
        }

        if (this.isEmpty(this.queryInfo.relatedStudent1)) {
          msg = '請選擇與學生關係1'
          return msg
        }
      }

      // 關係人2：以姓名是否填寫為觸發條件
      if (!this.isEmpty(this.queryInfo.relatedName2)) {
        if (this.isEmpty(this.queryInfo.relatedId2)) {
          msg = '請輸入關係人身分證2'
          return msg
        }

        var ret2 = this.queryInfo.relatedNationality2 === 'TW'
          ? tools.checkTWID(this.queryInfo.relatedId2)
          : tools.checkARC(this.queryInfo.relatedId2)
        if (!ret2) {
          msg = '關係人2身分證/居留證格式不正確'
          return msg
        }

        if (!tools.checkGenderMatch(this.queryInfo.relatedId2, this.queryInfo.relatedNationality2, this.queryInfo.relatedStudent2)) {
          msg = '關係人2性別與關係不符（父親應為男性、母親應為女性）'
          return msg
        }

        if (this.isEmpty(this.queryInfo.relatedStudent2)) {
          msg = '請選擇與學生關係2'
          return msg
        }
      }

      // 關係人3：以姓名是否填寫為觸發條件
      if (!this.isEmpty(this.queryInfo.relatedName3)) {
        if (this.isEmpty(this.queryInfo.relatedId3)) {
          msg = '請輸入關係人身分證3'
          return msg
        }

        var ret3 = this.queryInfo.relatedNationality3 === 'TW'
          ? tools.checkTWID(this.queryInfo.relatedId3)
          : tools.checkARC(this.queryInfo.relatedId3)
        if (!ret3) {
          msg = '關係人3身分證/居留證格式不正確'
          return msg
        }

        if (!tools.checkGenderMatch(this.queryInfo.relatedId3, this.queryInfo.relatedNationality3, this.queryInfo.relatedStudent3)) {
          msg = '關係人3性別與關係不符（父親應為男性、母親應為女性）'
          return msg
        }

        if (this.isEmpty(this.queryInfo.relatedStudent3)) {
          msg = '請選擇與學生關係3'
          return msg
        }
      }

      // 戶籍謄本：現有檔案或新上傳擇一即可
      if (this.FileisEmpty(this.queryInfo.file)) {
        msg = '請上傳戶籍謄本'
        return msg
      }

      // 若已選取新檔案，確認已成功上傳至伺服器
      if (this.queryInfo.file instanceof File && this.queryInfo.file.size > 0) {
        if (!this.queryInfo.Info1 || this.queryInfo.Info1.length === 0) {
          msg = '戶籍謄本上傳尚未完成，請稍候再試'
          return msg
        }
      }

      return msg
    },
    confirmRM () {
      var vm = this
      vm.eid = vm._props.id
      if (vm.queryInfo.file.size > 0) {
        this.$http
          .get('./WebApi/EconomicDisadvantage/DeleteApplyPDF2/'.concat(vm.eid))
          .then((response) => {
            if (response.data) {
              // tools.showAlert(vm, "success", "恭喜您,刪除成功");
              vm.editCase()
            } else {
              // tools.showAlert(vm, "danger", "對不起,刪除失敗");
              vm.editCase()
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, 'danger', '網路連線失敗' + error)
          })
      } else {
        vm.editCase()
      }
    },
    /**
     * 使用者選取檔案後觸發（index=0 對應戶籍謄本）。
     * 流程：副檔名驗證 → 組 FormData → POST 至 UploadV3
     *       → 成功後寫入 queryInfo.Info1 並標記 DataMode=1（需重新上傳）
     *       → 失敗時重設 file 及 file input。
     */
    fileChange (index) {
      this.formData = new FormData()

      const allowedExtensions = ['jpg', 'jpeg', 'png', 'gif', 'pdf']

      if (!this.queryInfo.file) return

      const fileName = this.queryInfo.file.name || ''
      const extension = fileName.split('.').pop().toLowerCase()

      if (!allowedExtensions.includes(extension)) {
        alert('檔案格式錯誤，僅限上傳 JPG, PNG, GIF, PDF 檔案')
        this.queryInfo.file = null
        this.$refs['file-input'].reset()
        return
      }

      if (index === 0) {
        this.formData.append('header', this.queryInfo.file)
      }

      this.$http
        .post('./WebApi/Common/UploadV3', this.formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: function (progressEvent) {
            console.log(
              'Upload progress: ' +
                Math.round((progressEvent.loaded / progressEvent.total) * 100) + '%'
            )
          }
        })
        .then((response) => {
          this.queryInfo.Info1 = response.data
          this.queryInfo.DataMode = 1
        })
        .catch((error) => {
          this.queryInfo.file = null
          this.$refs['file-input'].reset()
          tools.showAlert(this, 'danger', '網路連線失敗，請重新上傳：' + error)
        })
    },

    // 備用上傳方案（使用 UploadV2 端點，保留以備回退參考）
    // fileChange(index) {
    //   // 清除舊的 FormData
    //   this.formData = new FormData();

    //   const allowedExtensions = ['jpg', 'jpeg', 'png', 'gif', 'pdf'];

    //   // 檢查是否有檔案
    //   if (!this.file) return;

    //   const fileName = this.file.name || '';
    //   const extension = fileName.split('.').pop().toLowerCase();

    //   // 副檔名驗證
    //   if (!allowedExtensions.includes(extension)) {
    //     alert('檔案格式錯誤，僅限上傳 JPG, PNG, GIF, PDF 檔案');
    //     this.file = null;
    //     this.$refs['file-input'].reset();
    //     return;
    //   }

    //   if (index === 0) {
    //     this.id1 = this.id1 + this.generateRandomString();
    //     this.formData.append(this.id1, this.file);
    //   }

    //   this.$http
    //     .post('./WebApi/Common/UploadV2', this.formData)
    //     .then((response) => {
    //       if (!tools.isNull(response.data)) {
    //         if (index === 0) this.queryInfo.Info1 = response.data;
    //       } else {
    //         tools.showAlert(this, 'danger', '上傳檔案失敗，請重新上傳');
    //       }
    //     })
    //     .catch((error) => {
    //       tools.showAlert(this, 'danger', '網路連線失敗，請重新上傳：' + error);
    //     });
    // },

    // 取得今日的民國年日期字串，格式為 yyy/MM/dd
    getToday () {
      var dd = new Date()
      var today = dd.getDate().toString().padStart(2, '0') // 內建 getDate 取到目前年月日
      var mm = (dd.getMonth() + 1).toString().padStart(2, '0') // January is 0!
      var yyyy = dd.getFullYear()
      return tools.stringFormat('{0}/{1}/{2}', yyyy - 1911, mm, today)
    },
    // 執行欄位驗證後呼叫 PUT API 更新案件資料，成功後通知父元件返回列表
    editCase: function () {
      var msg = this.checkSaveData()
      if (msg.length !== 0) {
        alert(msg)
        return null
      }

      const vm = this

      vm.$http
        .put('./WebApi/EconomicDisadvantage/EditCase/', vm.queryInfo)
        .then((response) => {
          if (response.data > 0) {
            alert('更新上傳成功')
            vm.CaseSelect(1)
          } else {
            alert('更新上傳失敗')
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
        })
    },

    // 取得目前系統設定的開放申請學年期，填入 queryInfo 以顯示於表單
    GetCurrentSchyy () {
      const vm = this

      this.$http
        .get('./WebApi/EconomicDisadvantage/GetCurrentSchyy/')
        .then((response) => {
          if (response.data !== null && response.data !== 0) {
            vm.queryInfo.schyy = response.data.schyy
            vm.queryInfo.smt = response.data.smt
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
        })
    },
    // 依傳入的案件 id 向 API 取得案件詳細資料，並填入 queryInfo 供表單顯示與編輯
    getCaseDetail () {
      const vm = this

      vm.eid = vm._props.id
      this.$http
        .get('../WebApi/EconomicDisadvantage/GetCaseDetail/'.concat(vm.eid))
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.CaseShow = true
            vm.inputData = response.data
            vm.queryInfo.id = response.data[0].id
            vm.queryInfo.sid = response.data[0].sid
            vm.queryInfo.stdID = response.data[0].stdID
            vm.queryInfo.schyy = response.data[0].schyy
            vm.queryInfo.smt = response.data[0].smt
            vm.queryInfo.UpdateUser = response.data[0].sid
            vm.queryInfo.reason = '補件'
            vm.queryInfo.relatedName1 = response.data[0].relatedName1
            vm.queryInfo.relatedName2 = response.data[0].relatedName2
            vm.queryInfo.relatedName3 = response.data[0].relatedName3
            vm.queryInfo.relatedId1 = response.data[0].relatedId1
            vm.queryInfo.relatedId2 = response.data[0].relatedId2
            vm.queryInfo.relatedId3 = response.data[0].relatedId3
            vm.queryInfo.relatedStudent1 = response.data[0].relatedStudent1
            vm.queryInfo.relatedStudent2 = response.data[0].relatedStudent2
            vm.queryInfo.relatedStudent3 = response.data[0].relatedStudent3
            const idToNat = id => (!id || id[1] === '1' || id[1] === '2') ? 'TW' : 'FN'
            vm.queryInfo.relatedNationality1 = idToNat(response.data[0].relatedId1)
            vm.queryInfo.relatedNationality2 = idToNat(response.data[0].relatedId2)
            vm.queryInfo.relatedNationality3 = idToNat(response.data[0].relatedId3)

            // attachInfoString 為 JSON 字串時解析取得現有附件的 RowId 與檔名
            if (response.data[0].attachInfoString !== 'null') {
              const jsonArr = JSON.parse(response.data[0].attachInfoString)
              vm.queryInfo.file.name = jsonArr.FileNm
              vm.queryInfo.file.RowId = jsonArr.RowId
              vm.queryInfo.rowId = jsonArr.RowId
            }
          }
        })
        .catch(function (error) {
          alert('網路連線失敗' + error)
        })
    }
  },
  created () {
    console.log('======created EditCase2 =====')
    this.GetCurrentSchyy()
  },
  mounted () {
    console.log('======mounted EditCase2  =====')
    this.getCaseDetail()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 關係人表格欄位對齊：header 列與 data 列使用相同 rel-row class，透過 nth-child 固定每欄寬度 */
.rel-row > div:nth-child(1) { width: 3.5rem; text-align: center; justify-content: center; }
.rel-row > div:nth-child(3) { min-width: 9rem; }
.rel-row > div:nth-child(4) { min-width: 7rem; }
</style>
